import { GoogleOAuthProvider } from "@react-oauth/google";
import { PostHogProvider } from "@posthog/react";
// import * as Sentry from "@sentry/react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import App from "./App";
import "./i18n";
import "./index.css";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";

// Sentry.init({
//   dsn: "https://f1b0756c98e2748c05e2c08a563ef725@o4508678154223616.ingest.de.sentry.io/4508678157631568",
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEYS}`);
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  ui_host: process.env.REACT_APP_POSTHOG_UI_HOST,
} as const;

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY || ""} options={posthogOptions}>
        <Elements stripe={stripePromise}>
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </GoogleOAuthProvider>
        </Elements>
      </PostHogProvider>
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
